@if (!viewOnly()) {
<div class="visual-editor-box__input-horizontal mb-10">
  <ng-content select="[beforeType]"></ng-content>

  <label>Category</label>
  @if (showFieldSelector()) {
    <mat-select class="trg-outline user-select-none h-24 text-ellipsis"
                panelClass="trg-outline-dropdown"
                [value]="group()"
                (valueChange)="setGroup($event)"
                placeholder="Please Select"
                [disabled]="!groups().length">
      @for (g of groups(); track g.id) {
        <mat-option [value]="g"
                    [disabled]="!g.items.length"
                    [title]="g.title"
                    class="text-ellipsis">{{g.title}}</mat-option>
      }
    </mat-select>
  }
  @else {
    <span class="d-flex trg-outline-box user-select-none h-24 c-red-2 bc-red-2 align-items-center px-5">
      {{invalidFieldDetails()?.group}}
    </span>
  }

  <label>Field Name</label>
  @if (showFieldSelector()) {
    <mat-select class="trg-outline user-select-none h-24 select-trigger-w-100p text-ellipsis"
                panelClass="trg-outline-dropdown min-w-250"
                [value]="item()"
                (valueChange)="setItem($event)"
                placeholder="Please Select"
                [disabled]="!items().length">
      <mat-select-trigger>
        @let _item = item();
        @if (_item) {
          <div class="text-ellipsis pr-4" [title]="_item.longTitle()">
            <span>
              <i class="{{_item.icon()}} mr-6"></i>
              <span>
                @if (_item.parent) { <span>{{_item.parent.shortTitle()}} - </span> }
                <span>{{_item.shortTitle()}}</span>
              </span>
            </span>
          </div>
        }
      </mat-select-trigger>
      @for (i of items(); track i.id) {
        <mat-option [value]="i"
                    [hidden]="!!i.parent?.collapsed()"
                    class="text-ellipsis">
          <div class="d-inline-flex align-items-center justify-content-between text-ellipsis w-100p h-24" [title]="i.longTitle()"
                [class.dropdown-child]="!!i.parent">
            <span [class.pl-15]="!!i.parent" class="text-ellipsis">
              <i class="{{i.icon()}} mr-6"></i>
              <span>{{i.shortTitle()}}</span>
            </span>
            <visual-editor-field-icons [field]="i.target()">
              <ng-container beforeDataTypeIcon>
                @if (i.hasChildren) {
                  <span class="pointer p-4" (click)="toggleItem(i, $event)">
                    <i class="fas {{(i.collapsed() ? 'fa-chevron-down' : 'fa-chevron-up')}}"></i>
                  </span>
                }
              </ng-container>
            </visual-editor-field-icons>
          </div>
        </mat-option>
      }
    </mat-select>
  }
  @else {
    <span class="d-flex trg-outline-box user-select-none h-24 c-red-2 bc-red-2 align-items-center px-5 text-ellipsis">
      <i class="fas fa-exclamation-triangle w-18"></i>
      <span>{{invalidFieldDetails()?.field}}</span>
    </span>
  }
  
  <label>Type</label>
  <mat-select class="trg-outline user-select-none h-24 text-ellipsis"
              panelClass="trg-outline-dropdown"
              [value]="type()"
              (valueChange)="setType($event)"
              placeholder="Please Select"
              [disabled]="!types().length">
    @for (t of types(); track t.type) {
      <mat-option [value]="t">{{t.title}}</mat-option>
    }
  </mat-select>

  <div class="d-contents" [hidden]="!canSelectAggregation()">
    <label>Aggregation</label>
    @if (showFieldSelector()) {
      <mat-select class="trg-outline user-select-none h-24 select-trigger-w-100p text-ellipsis"
                  panelClass="trg-outline-dropdown"
                  [ngModel]="itemAggregation()"
                  (ngModelChange)="setItemAggregation($event?.value)">
        <mat-select-trigger>
          @let a = itemAggregation();
          @if (a) {
            <span>{{a.title}}</span>
          }
          @else {
            <span>Unaggregated</span>
          }
        </mat-select-trigger>

        @for (a of aggregations(); track a.value) {
          <mat-option [value]="a" 
                      [title]="a.title"
                      class="text-ellipsis">
            <span>{{a.title}}</span>
          </mat-option>
        }
      </mat-select>
    }
    @else {
      <span class="d-flex trg-outline-box user-select-none h-24 c-red-2 bc-red-2 align-items-center px-5 text-ellipsis">
        <i class="fas fa-exclamation-triangle w-18"></i>
        <span>{{invalidFieldDetails()?.aggregation}}</span>
      </span>
    }
  </div>
</div>
}

@if (predicate()) {
  @if (isBasic()) {
    <filter-editor__basic [predicate]="predicate()"
                          (predicateChange)="setPredicate($event)" 
                          [context]="context()"
                          [dataSource]="dataSource()"
                          [customFields]="customFields()"></filter-editor__basic>
  }
  @else if (isAdvanced()) {
    <filter-editor__advanced [predicate]="predicate()" 
                             (predicateChange)="setPredicate($event)"></filter-editor__advanced>
  }
  @else if (isDynamic()) {
    <filter-editor__dynamic [predicate]="predicate()" 
                            (predicateChange)="setPredicate($event)"></filter-editor__dynamic>
  }
  @else if (isRelativeDate() || isRelativeTime()) {
    <filter-editor__relativeDateOrTime [predicate]="predicate()" 
                                       (predicateChange)="setPredicate($event)"></filter-editor__relativeDateOrTime>
  }
  @else if (isTopN()) {
    <filter-editor__topn [predicate]="predicate()"
                         (predicateChange)="setPredicate($event)"></filter-editor__topn>
  }
}